import React, { useEffect } from 'react'
import { Form, Input, message } from 'antd'
import { Modal } from '~/Components/Modal'
import { UserService } from '~/Services'

interface ChangePasswordProps {
  visible: boolean
  onClose: () => void
}

interface ChangePasswordFormValues {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}

export const ChangePassword: React.FC<ChangePasswordProps> = ({
  visible,
  onClose,
}) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = React.useState(false)

  useEffect(() => {
    if (visible) {
      form.resetFields()
    }
  }, [visible, form])

  const handleSubmit = async (values: ChangePasswordFormValues) => {
    try {
      setLoading(true)
      
      await UserService.Put.changePassword({
        oldPassword: values.currentPassword,
        newPassword: values.newPassword,
      })

      message.success('Đổi mật khẩu thành công!')
      form.resetFields()
      onClose()
    } catch (error: any) {
      message.error(error?.response?.data?.message || 'Đổi mật khẩu thất bại!')
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      title="Thay đổi mật khẩu"
      visible={visible}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      confirmLoading={loading}
      width={500}
      okText="Đổi mật khẩu"
      cancelText="Hủy"
      loadingData={loading}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Mật khẩu hiện tại"
          name="currentPassword"
          rules={[
            { required: true, message: 'Vui lòng nhập mật khẩu hiện tại!' },
          ]}
        >
          <Input.Password placeholder="Nhập mật khẩu hiện tại" />
        </Form.Item>

        <Form.Item
          label="Mật khẩu mới"
          name="newPassword"
          rules={[
            { required: true, message: 'Vui lòng nhập mật khẩu mới!' },
            { min: 6, message: 'Mật khẩu tối thiểu 6 ký tự!' },
          ]}
        >
          <Input.Password placeholder="Nhập mật khẩu mới" />
        </Form.Item>

        <Form.Item
          label="Nhập lại mật khẩu mới"
          name="confirmPassword"
          dependencies={['newPassword']}
          hasFeedback
          rules={[
            { required: true, message: 'Vui lòng nhập lại mật khẩu mới!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const newPassword = getFieldValue('newPassword')
                if (!value || newPassword === value) {
                  return Promise.resolve()
                }
                return Promise.reject(
                  new Error('Mật khẩu xác nhận không khớp!'),
                )
              },
            }),
          ]}
        >
          <Input.Password placeholder="Nhập lại mật khẩu mới" />
        </Form.Item>
      </Form>
    </Modal>
  )
}